<template>
  <div class="wrapper">
    <div class="wrapper_main">
      <div class="top">
        图层列表
      </div>
      <div class="content">
        <el-form ref="form" :model="selectForm" inline class="formStyle" size="small">
          <div>
            <el-dropdown @command="handleCommand">
              <el-button type="primary" size="small">
                批量设置<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item,index) in setList" :key="index" :command="item.name">{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div>
            <el-form-item label="提资方:">
              <el-select v-model="selectForm.carrySpecId" size="small" placeholder="请选择" clearable filterable
                @change="getList(1)">
                <el-option v-for="item in dict.specialty" :key="item.specId" :label="item.specName"
                  :value="item.specId" />
              </el-select>
            </el-form-item>
            <el-form-item label="接收方:">
              <el-select v-model="selectForm.receiveSpecId" size="small" placeholder="请选择" clearable filterable
                @change="changeReceiveSpecId">
                <el-option v-for="item in dict.specialty" :key="item.specId" :label="item.specName"
                  :value="item.specId" />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <el-table :data="list" border height="100%" @selection-change="handleSelectionChange">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              请选择提资方和接收方信息
            </p>
          </template>
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column type="index" label="序号" width="60px" align="center" />
          <el-table-column label="提资方" align="center" prop="layerType" />
          <el-table-column label="接收方" align="center" prop="receiveSpec" />
          <el-table-column label="图层名" prop="layerName" align="center" />
          <el-table-column label="显示线型" prop="lineType" align="center" />
          <el-table-column label="显示线宽" prop="lineWeight" align="center" />
          <el-table-column label="显示颜色" prop="colour" align="center" />
          <el-table-column label="打印样式" prop="plotStyle" align="center" />
          <el-table-column label="是否关闭" prop="isChoose" align="center" width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isChoose" @change="changeStatus(row.isChoose, row)" />
            </template>
          </el-table-column>
          <el-table-column label="是否冻结" prop="isFrozen" align="center" width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isFrozen" @change="changeStatus(row.isFrozen, row)" />
            </template>
          </el-table-column>
          <el-table-column label="是否锁定" prop="isLocked" align="center" width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isLocked" @change="changeStatus(row.isLocked, row)" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination v-if="page.totalCount>0" :total="page.totalCount" :current-page="page.pageIndex"
          :page-size="page.pageSize" :page-sizes="[10, 20, 50, 100]" background
          layout="total,sizes, prev, pager, next,jumper" @size-change="handleSizeChange" @current-change="getList" />
      </div>
    </div>
  </div>
</template>
<script>
import collaborationLayerService from "@/CommonDP/service/collaborationLayer-service";
import standardTemplateService from "@/CommonDP/service/standardTemplate-service";
import { mapState } from "vuex";
export default {
  name: "CollaborationLayer",
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      dict: {
        specialty: []
      },
      list: [],
      page: { pageIndex: 1, pageSize: 20, totalCount: 0 },
      name: "",
      selectForm: {
        carrySpecId: "",
        receiveSpecId: "",
        receiveSpecName: ""
      },
      setList: [
        {
          name: '关闭',
          value: 1,
          type: 'isChoose'
        }, {
          name: '取消关闭',
          value: 0,
          type: 'isChoose'
        }, {
          name: '冻结',
          value: 1,
          type: 'isFrozen'
        }, {
          name: '取消冻结',
          value: 0,
          type: 'isFrozen'
        }, {
          name: '锁定',
          value: 1,
          type: 'isLocked'
        }, {
          name: '取消锁定',
          value: 0,
          type: 'isLocked'
        }
      ],
      multipleSelection: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getDict();
    this.getList(1);
  },
  methods: {
    // 字典
    async getDict() {
      const { data } = await standardTemplateService.getSpecListStandard(this.enterpriseId);
      this.dict.specialty = data;
    },
    // 默认选择
    async changeStatus(status, row) {
      const params = {
        type: 1,
        layerId: row.layerId,
        receiveSpecId: row.receiveSpecId,
        isChoose: row.isChoose ? 1 : 0,
        isFrozen: row.isFrozen ? 1 : 0,
        isLocked: row.isLocked ? 1 : 0
      };
      await collaborationLayerService.updateCollaborationLayerStatus(params);
      if (status) this.$message.success("选择成功");
      else this.$message.success("取消选择");
    },
    // 翻页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList(1);
    },
    // 表格数据
    async getList(pageNo = this.page.pageIndex) {
      const res = await collaborationLayerService.getcollaborationLayerList({
        ...this.selectForm,
        pageNum: pageNo,
        type: 1,
        pageSize: this.page.pageSize,
        enterpriseId: this.enterpriseId
      });
      this.list = res.data;
      this.page.pageIndex = res.pageIndex;
      this.page.totalCount = res.totalCount;
      this.page.pageSize = res.pageSize;
    },
    // 切换接收方
    changeReceiveSpecId(val) {
      if (val) {
        this.selectForm.receiveSpecName = this.dict.specialty.find((ele) => ele.specId === val).specName;
      } else {
        this.selectForm.receiveSpecName = "";
      }
      this.getList(1);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async handleCommand(command) {
      if (!this.multipleSelection.length) {
        this.$message.warning("请先选择要批量设置的数据");
        return;
      }
      const typeObj = this.setList.filter(({ name }) => name === command)[0];
      const params = [];
      this.multipleSelection.forEach(ele => {
        const data = {
          type: 1,
          layerId: ele.layerId,
          receiveSpecId: ele.receiveSpecId,
          isChoose: ele.isChoose ? 1 : 0,
          isFrozen: ele.isFrozen ? 1 : 0,
          isLocked: ele.isLocked ? 1 : 0
        };
        data[typeObj.type] = typeObj.value;
        params.push(data);
      });
      await collaborationLayerService.batchUpdateCollaborationLayerStatus(params);
      this.$message.success("批量设置成功");
      this.getList(1);
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  background-color: #fff;
  .wrapper_main {
    height: 100%;
    display: flex;
    flex-direction: column;
    .top {
      font-weight: 700;
      font-size: 16px;
      color: var(--key-color);
      border-bottom: 1px solid #ebefff;
      padding: var(--middle-space) var(--big-space);
    }

    .content {
      height: 1px;
      flex-grow: 1;
      padding: var(--middle-space) var(--big-space);
      display: flex;
      flex-direction: column;
      .formStyle {
        display: flex;
        justify-content: space-between;
        /deep/ .el-input__suffix {
          top: -2px;
        }
      }
      .el-table{
        flex-grow: 1;
      }
    }
    .footer {
      text-align: right;
      padding: 0 var(--big-space) var(--middle-space);
    }
  }
}
</style>
